import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-semibold mb-16 text-center lg:text-left" }, " Nuestro Trabajo ", -1)
const _hoisted_2 = ["src"]

import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide } from "vue3-carousel";

export default /*#__PURE__*/_defineComponent({
  __name: 'GalleryComponent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_unref(Carousel), {
      autoplay: 2000,
      itemsToShow: 3.5,
      wrapAround: true,
      transition: 500
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (slide) => {
          return _createVNode(_unref(Slide), { key: slide }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: require(`@/assets/gallery/${slide}.png`),
                alt: "",
                class: "w-full"
              }, null, 8, _hoisted_2)
            ]),
            _: 2
          }, 1024)
        }), 64))
      ]),
      _: 1
    })
  ], 64))
}
}

})